






















































































































































































import mixins from 'vue-typed-mixins'

import I18N from '@/components/I18N.ts'
import SearchInput from '@/components/SearchInput.vue'
import Suggest from '@/components/Suggest.vue'
import Root from '@/components/Root.vue'
import Highlight from '@/components/Highlight.vue'
import * as UI from '@/helpers/UI.ts'

import axios from 'axios'

function query2bool (val: any, def: boolean = true): boolean {
  if (val !== undefined) {
    return val === '1' || val === 'true'
  } else {
    return def
  }
}

function bool2query (val: boolean): string {
  return val ? '1' : '0'
}

interface Data {
  pos: string[] // for dropdown
  sources: string[] // for dropdown
  search: {
    s: string
    l: boolean
    wf: boolean
    g: boolean
    pos: string | null
    source: string | null
    pending: boolean
  },
  page: number // last page retrieved
  working: boolean
  results: Result[]
  resultCount: number // as reported by server, only equal to resuls.length when all results loaded
  searchSuggestions: string[]
  suggest: {
    show: boolean // is suggest modal showing
    done: boolean // successfully submitted
  }
}

interface Result {
  lexeme: Lexeme
  wordforms: Wordform[] | null
}

export default mixins(I18N).extend({
  components: {
    SearchInput,
    Suggest,
    Root,
    Highlight
  },
  data (): Data {
    return {
      pos: ['ADJ', 'ADP', 'ADV', 'AUX', 'CONJ', 'DET', 'INTJ', 'NOUN', 'NUM', 'PART', 'PRON', 'PROPN', 'PUNCT', 'SCONJ', 'SYM', 'VERB', 'X'],
      sources: [], // loaded async
      search: {
        // These default values are overwritten by watch below
        s: '',
        l: true,
        wf: true,
        g: true,
        pos: null,
        source: null,
        pending: false
      },
      page: 0,
      working: false,
      results: [],
      resultCount: 0,
      searchSuggestions: [],
      suggest: {
        show: false,
        done: false
      }
    }
  },
  watch: {
    // Populate local search object whenever URL changes
    '$route.query': {
      handler (): void {
        this.search = {
          s: this.$route.query.s as string || '',
          l: query2bool(this.$route.query.l, true),
          wf: query2bool(this.$route.query.wf, true),
          g: query2bool(this.$route.query.g, true),
          pos: this.$route.query.pos as string || null,
          source: this.$route.query.source as string || null,
          pending: query2bool(this.$route.query.pending, false)
        }
        if (this.isSearching) {
          this.results = []
          this.resultCount = 0
          this.page = 0
          this.loadResults()
          this.searchSuggest()
          this.$store.dispatch('setTitle', { key: 'title.search', replacements: [this.search.s] })
        } else {
          this.$store.dispatch('setTitle', { key: 'Advanced search' })
        }
      },
      immediate: true
    }
  },
  computed: {
    isSearching (): boolean {
      return this.$route.query.s !== undefined && this.$route.query.s !== null && this.$route.query.s !== ''
    },
    moreResults (): boolean {
      return this.results.length < this.resultCount
    },
    searchSuggestionsFiltered (): string[] {
      return this.searchSuggestions.filter((s: string) =>
        !this.results.some((r: Result) => r.lexeme.lemma === s)
      )
    }
  },
  methods: {
    // the form is submitted
    submitSearch (): void {
      this.$router.push({
        query: {
          s: this.search.s,
          l: bool2query(this.search.l),
          wf: bool2query(this.search.wf),
          g: bool2query(this.search.g),
          pos: this.search.pos,
          source: this.search.source,
          pending: bool2query(this.search.pending)
        }
      })
    },
    // get results
    loadResults (): void {
      this.working = true
      this.suggest.show = false
      this.suggest.done = false
      this.$store.dispatch('clearMessages')
      axios.get(`${process.env.VUE_APP_API_URL}/lexemes/search`, {
        params: {
          s: this.search.s,
          l: bool2query(this.search.l),
          wf: bool2query(this.search.wf),
          g: bool2query(this.search.g),
          pos: this.search.pos,
          source: this.search.source,
          pending: bool2query(this.search.pending),
          page: ++this.page
        } })
        .then(response => {
          response.data.results.forEach((r: Result) => {
            r.wordforms = null // not loaded
            this.results.push(r)
            axios.get(`${process.env.VUE_APP_API_URL}/lexemes/wordforms/${r.lexeme._id}`)
              .then(resp => {
                r.wordforms = resp.data
              })
              .catch(error => {
                this.$store.dispatch('addError', error)
                r.wordforms = []
              })
          })
          this.resultCount = response.data.query.result_count
        })
        .catch(error => {
          this.$store.dispatch('addError', error)
        })
        .then(() => {
          this.working = false
        })
    },
    // search suggestions
    searchSuggest (): void {
      this.searchSuggestions = []
      // axios.get(`${process.env.VUE_APP_API_URL}/lexemes/search_suggest`, {
      //   params: {
      //     s: this.search.s
      //   } })
      //   .then(response => {
      //     response.data.results.forEach((r: {lexeme: Lexeme}) => {
      //       if (!this.searchSuggestions.includes(r.lexeme.lemma)) {
      //         this.searchSuggestions.push(r.lexeme.lemma)
      //       }
      //     })
      //   })
      //   .catch(error => {
      //     console.error(error)
      //   })
      axios.get(`${process.env.VUE_APP_API_URL}/wordforms/search_suggest`, {
        params: {
          s: this.search.s
        } })
        .then(response => {
          response.data.results.forEach((r: {wordform: Wordform}) => {
            if (!this.searchSuggestions.includes(r.wordform.surface_form)) {
              this.searchSuggestions.push(r.wordform.surface_form)
            }
          })
        })
        .catch(error => {
          console.error(error)
        })
    },
    // Making helper functions available to template
    derivedForm: UI.derivedForm,
    agr: UI.agr
  },
  mounted (): void {
    // https://renatello.com/check-if-a-user-has-scrolled-to-the-bottom-in-vue-js/
    window.onscroll = () => {
      let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight
      if (bottomOfWindow && !this.working && this.moreResults) {
        this.loadResults()
      }
    }

    axios.get(`${process.env.VUE_APP_API_URL}/sources`)
      .then(response => {
        this.sources = response.data.map((s: Source) => s.key)
      })
      .catch(error => {
        console.error(error)
      })
  }
})
